import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";
import router from "../../../../router";

const getTranslationModule = {
    namespaced: true,
    state: {
        translationData: {},
        loadingTranslations: false,
        changedItems: [],
    },
    mutations: {
        GET_TRANSLATION_MODULE_SUCCESS(state, response) {
            state.translationData = response.data.data;
            state.loadingTranslations = false;
            eventBus.$emit("getTranslationModuleSuccess", state.translationData);
        },
        GET_TRANSLATION_MODULE_FAILURE(state, error) {
            console.log(error);
        },
    },
    actions: {
        getTranslationModuleRequest: function({ dispatch, state }) {
            state.loadingTranslations = true;
            let promise = sendRequest("get", config.baseURLApi + router.currentRoute.path, {}, {}, true);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetTranslationModule", result[1]);
                } else {
                    dispatch("failureGetTranslationModule", result[1]);
                }
            })
        },
        successGetTranslationModule: function({ commit }, response) {
            commit("GET_TRANSLATION_MODULE_SUCCESS", response);
        },
        failureGetTranslationModule: function({ commit }, error) {
            commit("GET_TRANSLATION_MODULE_FAILURE", error);
        },
    }
}

export default getTranslationModule;